<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      :order="1"
      :inputArr="inputArr"
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
    />

    <!-- 列表 -->
    <my-table
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
    />

    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>
<script>
import { appUserList } from "@/network/system/appUser";
import mixins from "@/mixins/common";
export default {
  name: "appUser",
  mixins:[mixins],
  provide() {
    return {
      importType: "appUser",
      initData: this.getInitData,
    };
  },
  watch: {
    tableData: {
      handler(val) {
        // console.log(val);
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        {
          name: "用户姓名",
          prop: "userZh",
        },
        {
          name: "登录名",
          prop: "username",
        },
        {
          name: "手机号码",
          prop: "tel",
        },
        {
          name: "电子邮箱",
          prop: "mail",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
      ]),
      //筛选时文本框所需参数
      inputArr: [
		{
		 name: "userZh",
		 defaultText: "请输入用户姓名",
		},
		{
		 name: "username",
		 defaultText: "请输入登录名",
		},
		{
		 name: "tel",
		 defaultText: "请输入手机号码",
		},
      ],
      //搜索参数
      searchParams: {
        timeOptions: "",
        userZh: "",
		username: "",
		tel: "",
      },
    };
  },
  methods: {
    getInitData() {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let params = {
        data: {
          userZh: this.searchParams.userZh,
          username: this.searchParams.username,
          tel: this.searchParams.tel,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
		current: this.pageParams.currentPage,
		size: this.pageParams.pageSize,
      };
      appUserList(params).then((e) => {
        this.loading = false;
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
        }
      });
    },
    //搜索事件
    searchEvent() {
	  this.pageParams.currentPage = 1;
      this.getInitData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

 
 